<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Email
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              First Name
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
               Last Name
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Role
              </th>
              <th scope="col" class="relative px-6 py-3">
                <span class="sr-only">Edit</span>
              </th>
            </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
            <tr v-if="people" v-for="person in people" :key="person.email">
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="flex items-center">
                  <div class="flex-shrink-0 h-10 w-10">
                    <img class="h-10 w-10 rounded-full" :src="person.avatar" alt="" />
                  </div>
                  <div class="ml-4">
                    <div class="text-sm font-medium text-gray-900">
                      {{ person.name }}
                    </div>
                    <div class="text-sm text-gray-500">
                      {{ person.email }}
                    </div>
                  </div>
                </div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="text-sm text-gray-900">{{ person.firstName }}</div>
<!--                <div class="text-sm text-gray-500">{{ // person.department }}</div>-->
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                  <span class="text-sm text-gray-900">
                   {{ person.lastName }}
                  </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ person.role }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <a href="#" class="text-indigo-600 hover:text-indigo-900 mr-3">Edit</a>
                <a href="#" class="text-red-500 hover:text-red-900">Delete</a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Faker from 'faker'
export default {
  name: "UsersTable",
  data() {
    return {
      people: null
    }
  },
  async mounted() {
    let people = await this.getPeople()
    this.people = people
  },
  methods: {
    getPeople: async function() {
      let peopleArray = []
      for (let i = 0; i <6; i++) {
        let avatar = await Faker.internet.avatar()
        let email = await Faker.internet.email()
        let firstName = await Faker.name.firstName()
        let lastName = await Faker.name.lastName()
        let person = {
          avatar: avatar,
          email: email,
          firstName: firstName,
          lastName: lastName,
          role: i % 2 === 0 ? 'Admin' : 'SuperAdmin'
        }
        peopleArray.push(person)
      }
      return peopleArray
    }
  }

  }

</script>

<style scoped>

</style>